<script setup lang="ts">
const props = defineProps<{
  label: string
  labelFor: string
  error?: string
}>()

const errorId = `${props.labelFor}-error`
</script>

<template>
  <div class="sa-form-group" :class="{ 'sa-form-group--invalid': Boolean(error) }">
    <label class="sa-form-label" :for="labelFor">{{ label }}</label>
    <slot :error-id="errorId" :has-error="Boolean(error)" />
    <p v-if="error" :id="errorId" class="sa-field-error" role="alert">
      {{ error }}
    </p>
  </div>
</template>
